var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 49,
    viewBox: "0 0 36 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.96,
    d: "M15.8035 28.5961L4.17105 29.0443C3.46603 29.0701 2.76669 28.9079 2.14316 28.574C1.51962 28.2401 0.993772 27.7464 0.618317 27.1422C0.242865 26.538 0.0309938 25.8446 0.00393813 25.1315C-0.0231176 24.4184 0.135592 23.7106 0.464162 23.0791L5.88881 12.6607L11.3364 2.2507C11.666 1.61898 12.1542 1.08618 12.752 0.705906C13.3497 0.325629 14.0359 0.111281 14.7416 0.0844205C15.4472 0.0575599 16.1474 0.219135 16.7717 0.552894C17.396 0.886651 17.9224 1.38082 18.298 1.98571L24.4947 11.9523L30.6906 21.9222C31.0664 22.5268 31.2782 23.2208 31.3048 23.9345C31.3314 24.6481 31.1719 25.3563 30.8421 25.9878C30.5123 26.6193 30.0238 27.1518 29.4259 27.5317C28.8283 27.9117 28.1421 28.1258 27.4365 28.1524L15.8035 28.5961Z",
    fill: "#032250"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    d: "M19.9543 19.674L31.5906 19.2563C32.2945 19.2331 32.9921 19.3974 33.6135 19.7325C34.2349 20.0677 34.7583 20.5621 35.1316 21.1663C35.5049 21.7704 35.7145 22.4631 35.74 23.175C35.7655 23.887 35.6057 24.5932 35.2764 25.223L29.8252 35.6327L24.3698 46.0315C24.0383 46.6626 23.5486 47.1943 22.9497 47.573C22.3508 47.952 21.6639 48.1646 20.9579 48.1901C20.252 48.2153 19.5519 48.0523 18.928 47.7173C18.3041 47.3822 17.7783 46.887 17.4035 46.2813L11.2298 36.2991L5.05607 26.318C4.6807 25.7126 4.46963 25.0179 4.44404 24.3038C4.41848 23.5897 4.57932 22.8814 4.91038 22.2501C5.24147 21.6189 5.73107 21.087 6.32997 20.7081C6.92884 20.3291 7.61583 20.1164 8.32182 20.0914L19.9543 19.674Z",
    fill: "#149DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 48.4615,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.017b94601e1437b747ec606eca61952d.svg";
export { ForwardRef as ReactComponent };